import Fernet from 'fernet';
import axios from 'axios';

const FERNET_KEY = '8y4Ia5t_jQpDr_PNlpSvye8Dmeft1HwnsC1OadsDRaI=';
const AUTO_LOGIN_URL = 'https://console.ffeleven.com/administration/num_reporting/auto_login';

const createLoginToken = (username, password) => {
  const secret = new Fernet.Secret(FERNET_KEY);
  const token = new Fernet.Token({
    secret: secret,
    time: Date.now(),
  });
  return token.encode([username, password].join(':'));
};

const toBooleanFlag = (value) => {
  if (value === true || value === 1 || value === '1' || value === 'true') return true;
  if (value === false || value === 0 || value === '0' || value === 'false') return false;
  return undefined;
};

const extractSuperUser = (data) => {
  const payload = data && data.payload;
  return toBooleanFlag(payload && payload.is_superuser);
};

const persistSuperUser = (data) => {
  const isSuper = extractSuperUser(data);
  if (isSuper === undefined) {
    localStorage.removeItem('is_superuser');
    return null;
  }
  localStorage.setItem('is_superuser', isSuper ? 'true' : 'false');
  return isSuper;
};

const autoLogin = async (username, password, loginUrl = AUTO_LOGIN_URL) => {
  const encryptedMessage = createLoginToken(username, password);
  const response = await axios.get(`${loginUrl}?token=${encryptedMessage}`, {
    withCredentials: true,
  });
  const data = response.data || {};
  return {
    success: data.status === 'SUCCESS',
    data,
  };
};

const getAutoLoginUrlForAdmin = (url) => {
  try {
    return `${new URL(url).origin}/administration/num_reporting/auto_login`;
  } catch (error) {
    return AUTO_LOGIN_URL;
  }
};

export const isSuperUser = () => localStorage.getItem('is_superuser') === 'true';

export const getSuperUserFlag = () => {
  const value = localStorage.getItem('is_superuser');
  if (value === 'true') return true;
  if (value === 'false') return false;
  return null;
};

export const refreshConsoleSession = async () => {
  const username = localStorage.getItem('username');
  const password = localStorage.getItem('console_password');
  if (!username || !password) {
    return false;
  }
  try {
    const result = await autoLogin(username, password);
    if (result.success) {
      persistSuperUser(result.data);
    }
    return result.success;
  } catch (error) {
    console.error('Failed to refresh console session:', error);
    return false;
  }
};

export const openConsoleAdmin = async (url) => {
  const popup = window.open('about:blank', '_blank');
  const username = localStorage.getItem('username');
  const password = localStorage.getItem('console_password');
  if (username && password) {
    try {
      await autoLogin(username, password, getAutoLoginUrlForAdmin(url));
    } catch (error) {
      console.error('Failed to refresh admin session:', error);
    }
  }
  if (popup && !popup.closed) {
    popup.opener = null;
    popup.location.href = url;
    return;
  }
  window.location.href = url;
};

export const authProvider = {
    login: async ({ username, password }) => {
      
      const handlelogin = async()=>{
        try {
          return await autoLogin(username, password);
        } catch (error) {
          console.error('Network or fetch error:', error);
          return { success: false, data: null };
        }
      }

      const result = await handlelogin();

      if (result.success) {
        localStorage.setItem('auth', 'true');
        localStorage.setItem('username',username);
        localStorage.setItem('console_password', password);
        persistSuperUser(result.data);
        return Promise.resolve();
      }else{
        return Promise.reject('Invalid credentials');
      } 
    },
    logout: () => {
      if(localStorage.getItem('auth') && localStorage.getItem("username")){
        localStorage.clear();
        return Promise.resolve();
      }
      return Promise.reject('Error in logging out !');
    },
    checkAuth: () => {
      return localStorage.getItem('auth') ? Promise.resolve() : Promise.reject();
    },
    checkError: (error) => Promise.reject(error),
    getPermissions: () => Promise.resolve(getSuperUserFlag()),
  };
